/**
 * ArtifactUI Component
 *
 * Renders UI artifacts based on their mode (document, collection, documentWithRecords).
 * Future: Will unify Forms and Entities into a single abstraction.
 */

import { FC, memo } from 'react';
import { Typography } from 'antd';
import { UIArtifact } from '#types/System.types';

const { Text } = Typography;

interface ArtifactUIProps {
  uiArtifact: UIArtifact;
  disabled?: boolean; // TODO: Use when artifact modes are implemented
}

const ArtifactUI: FC<ArtifactUIProps> = ({ uiArtifact }) => {
  switch (uiArtifact.artifactMode) {
    case 'document':
    case 'collection':
    case 'documentWithRecords':
      return (
        <Text type="secondary">
          Artifact mode &quot;{uiArtifact.artifactMode}&quot; not yet implemented
        </Text>
      );

    default:
      return (
        <Text type="danger">
          Unknown artifact mode: {(uiArtifact as UIArtifact).artifactMode}
        </Text>
      );
  }
};

ArtifactUI.displayName = 'ArtifactUI';

export default memo(ArtifactUI);
